import axios from "axios";

// const API_URL = "http://nergzglass.test/api";
const API_URL = "https://nergzglass.store/api";
export const Api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
